/**
 * Font Awesome configuration and icon exports
 * Configure the icons you want to use in your application
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faBriefcase,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faCreditCard,
  faBuilding,
  faGraduationCap,
  faHeart,
  faHome,
  faCar,
  faGamepad,
  faMusic,
  faCamera,
  faPalette,
  faCode,
  faAtom,
  faMedkit,
  faFootballBall,
  faPlane,
  faShoppingCart,
  faCoffee,
  faBook,
  faLaptop,
  faBicycle,
  faFilm,
  faMicrophone,
  faGuitar,
  faDumbbell,
  faSwimmer,
  faRunning,
  faTree,
  faGlobe,
  faRocket,
  faStar,
  faLightbulb,
  faWrench,
  faTools,
  faChartLine,
  faDollarSign,
  faCalendarAlt,
  faClock,
  faShield,
  faKey,
  faLock,
  faEye,
  faEyeSlash,
  faUndo,
  faUsers,
  faUserTie,
  faIdCard,
  faAddressCard,
} from '@fortawesome/free-solid-svg-icons';

import {
  faUser as faUserRegular,
  faBuilding as faBuildingRegular,
  faCalendarAlt as faCalendarRegular,
  faEnvelope as faEnvelopeRegular,
  faAddressCard as faAddressCardRegular,
} from '@fortawesome/free-regular-svg-icons';

// Add icons to the library
library.add(
  // Solid icons
  faUser,
  faBriefcase,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faCreditCard,
  faBuilding,
  faGraduationCap,
  faHeart,
  faHome,
  faCar,
  faGamepad,
  faMusic,
  faCamera,
  faPalette,
  faCode,
  faAtom,
  faMedkit,
  faFootballBall,
  faPlane,
  faShoppingCart,
  faCoffee,
  faBook,
  faLaptop,
  faBicycle,
  faFilm,
  faMicrophone,
  faGuitar,
  faDumbbell,
  faSwimmer,
  faRunning,
  faTree,
  faGlobe,
  faRocket,
  faStar,
  faLightbulb,
  faWrench,
  faTools,
  faChartLine,
  faDollarSign,
  faCalendarAlt,
  faClock,
  faShield,
  faKey,
  faLock,
  faEye,
  faEyeSlash,
  faUndo,
  faUsers,
  faUserTie,
  faIdCard,
  faAddressCard,
  // Regular icons
  faUserRegular,
  faBuildingRegular,
  faCalendarRegular,
  faEnvelopeRegular,
  faAddressCardRegular
);

// Export commonly used icons for easy importing
export {
  faUser,
  faBriefcase,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faCreditCard,
  faBuilding,
  faGraduationCap,
  faHeart,
  faHome,
  faCar,
  faGamepad,
  faMusic,
  faCamera,
  faPalette,
  faCode,
  faAtom,
  faMedkit,
  faFootballBall,
  faPlane,
  faShoppingCart,
  faCoffee,
  faBook,
  faLaptop,
  faBicycle,
  faFilm,
  faMicrophone,
  faGuitar,
  faDumbbell,
  faSwimmer,
  faRunning,
  faTree,
  faGlobe,
  faRocket,
  faStar,
  faLightbulb,
  faWrench,
  faTools,
  faChartLine,
  faDollarSign,
  faCalendarAlt,
  faClock,
  faShield,
  faKey,
  faLock,
  faEye,
  faUsers,
  faUserTie,
  faIdCard,
  faAddressCard,
};

// Icon options for dropdowns and selectors
export const iconOptions = [
  // Personal & Identity
  { value: 'user', label: 'Personal', icon: faUser, category: 'Personal' },
  { value: 'id-card', label: 'ID Card', icon: faIdCard, category: 'Personal' },
  {
    value: 'address-card',
    label: 'Address Card',
    icon: faAddressCard,
    category: 'Personal',
  },
  {
    value: 'heart',
    label: 'Personal Life',
    icon: faHeart,
    category: 'Personal',
  },

  // Work & Business
  { value: 'briefcase', label: 'Work', icon: faBriefcase, category: 'Work' },
  { value: 'building', label: 'Company', icon: faBuilding, category: 'Work' },
  {
    value: 'user-tie',
    label: 'Professional',
    icon: faUserTie,
    category: 'Work',
  },
  {
    value: 'graduation-cap',
    label: 'Education',
    icon: faGraduationCap,
    category: 'Work',
  },
  {
    value: 'chart-line',
    label: 'Analytics',
    icon: faChartLine,
    category: 'Work',
  },

  // Contact & Communication
  { value: 'phone', label: 'Phone', icon: faPhone, category: 'Contact' },
  { value: 'envelope', label: 'Email', icon: faEnvelope, category: 'Contact' },
  {
    value: 'map-marker-alt',
    label: 'Address',
    icon: faMapMarkerAlt,
    category: 'Contact',
  },
  { value: 'users', label: 'Contacts', icon: faUsers, category: 'Contact' },

  // Financial
  {
    value: 'credit-card',
    label: 'Financial',
    icon: faCreditCard,
    category: 'Financial',
  },
  {
    value: 'dollar-sign',
    label: 'Money',
    icon: faDollarSign,
    category: 'Financial',
  },

  // Security & Privacy
  { value: 'shield', label: 'Security', icon: faShield, category: 'Security' },
  { value: 'key', label: 'Keys', icon: faKey, category: 'Security' },
  { value: 'lock', label: 'Privacy', icon: faLock, category: 'Security' },
  { value: 'eye', label: 'Visibility', icon: faEye, category: 'Security' },

  // Lifestyle & Hobbies
  { value: 'home', label: 'Home', icon: faHome, category: 'Lifestyle' },
  { value: 'car', label: 'Transportation', icon: faCar, category: 'Lifestyle' },
  { value: 'gamepad', label: 'Gaming', icon: faGamepad, category: 'Lifestyle' },
  { value: 'music', label: 'Music', icon: faMusic, category: 'Lifestyle' },
  {
    value: 'camera',
    label: 'Photography',
    icon: faCamera,
    category: 'Lifestyle',
  },
  { value: 'palette', label: 'Art', icon: faPalette, category: 'Lifestyle' },
  { value: 'book', label: 'Reading', icon: faBook, category: 'Lifestyle' },
  {
    value: 'coffee',
    label: 'Food & Drink',
    icon: faCoffee,
    category: 'Lifestyle',
  },
  { value: 'film', label: 'Movies', icon: faFilm, category: 'Lifestyle' },

  // Technology
  { value: 'code', label: 'Programming', icon: faCode, category: 'Technology' },
  {
    value: 'laptop',
    label: 'Technology',
    icon: faLaptop,
    category: 'Technology',
  },
  { value: 'atom', label: 'Science', icon: faAtom, category: 'Technology' },
  {
    value: 'rocket',
    label: 'Innovation',
    icon: faRocket,
    category: 'Technology',
  },

  // Health & Fitness
  { value: 'medkit', label: 'Health', icon: faMedkit, category: 'Health' },
  { value: 'dumbbell', label: 'Fitness', icon: faDumbbell, category: 'Health' },
  { value: 'swimmer', label: 'Swimming', icon: faSwimmer, category: 'Health' },
  { value: 'running', label: 'Running', icon: faRunning, category: 'Health' },

  // Travel & Sports
  { value: 'plane', label: 'Travel', icon: faPlane, category: 'Travel' },
  { value: 'globe', label: 'International', icon: faGlobe, category: 'Travel' },
  {
    value: 'football-ball',
    label: 'Sports',
    icon: faFootballBall,
    category: 'Sports',
  },
  { value: 'bicycle', label: 'Cycling', icon: faBicycle, category: 'Sports' },

  // Music & Entertainment
  {
    value: 'microphone',
    label: 'Microphone',
    icon: faMicrophone,
    category: 'Entertainment',
  },
  {
    value: 'guitar',
    label: 'Music Instruments',
    icon: faGuitar,
    category: 'Entertainment',
  },

  // Utilities & Tools
  { value: 'tools', label: 'Tools', icon: faTools, category: 'Utilities' },
  { value: 'wrench', label: 'Settings', icon: faWrench, category: 'Utilities' },
  {
    value: 'calendar-alt',
    label: 'Calendar',
    icon: faCalendarAlt,
    category: 'Utilities',
  },
  { value: 'clock', label: 'Time', icon: faClock, category: 'Utilities' },
  {
    value: 'shopping-cart',
    label: 'Shopping',
    icon: faShoppingCart,
    category: 'Utilities',
  },

  // Nature & Environment
  { value: 'tree', label: 'Nature', icon: faTree, category: 'Nature' },

  // Inspiration & Success
  { value: 'star', label: 'Favorites', icon: faStar, category: 'General' },
  {
    value: 'lightbulb',
    label: 'Ideas',
    icon: faLightbulb,
    category: 'General',
  },
];
